import { axiosPrivate } from '@/shared/api/axios'
import type { TypeClient } from '@/shared/catalogs/type-client'
import { API } from '@/shared/constants/api'
import type { IAdvisor, IUser } from '../models/user'

export type ISearchUserResult = {
  user_id: string
  /** Id canónico `usr_`; `user_id` se conserva para los consumidores v1 del lookup. */
  publicId?: string
  name: string
  email: string
  type: 'user'
  typeUser: string
  avatar: string | null
}

export type ISearchClientResult = {
  client_id: string
  name: string
  email: string
  type: 'client'
  typeClient: TypeClient
  company?: string
  avatar: string | null
  gender?: string | null
}

export type ISearchUsersAndClientsResult = ISearchUserResult | ISearchClientResult

export type IUserLookup = {
  _id: string
  id: string
  username: string
  fullname: string
  email: string
  typeAccount: string
  role: string
}

/**
 * Lookups v1 que todavía alimentan módulos sin superficie v2 (clientes, negociaciones,
 * entregas, proyectos, portal). NO se migran al SDK v2 por su cuenta: sus consumidores
 * bindean el `_id` de Mongo y se lo mandan a endpoints v1 como filtro y como FK, mientras
 * que el presenter v2 sólo expone el id público `usr_`. Cada uno muere cuando se migra su
 * módulo consumidor. Ver `docs/architecture/api-v2/master-migration-checklist.md`.
 */
export const usersService = {
  getLookup: () => axiosPrivate.get<IUserLookup[]>(API.users.lookup).then((r) => r.data),

  getLookupAll: () => axiosPrivate.get<IUserLookup[]>(API.users.lookupAll).then((r) => r.data),

  getMe: () => axiosPrivate.get<IUser>(API.auth.me).then((r) => r.data),

  getAdvisors: () => axiosPrivate.get<IAdvisor[]>(API.users.advisor).then((r) => r.data),

  searchUsersAndClients: (query: string) =>
    axiosPrivate
      .get<ISearchUsersAndClientsResult[]>(API.users.searchUsersClients, {
        params: { query }
      })
      .then((r) => r.data)
}
